export const SAVE_SEARCH_EXCEPTIONS = {
  INVALID_EMAIL: 'The supplied email is invalid',
  LIMIT_REACHED:
    'Maximum Limit Reached for Saving Searches on this Device, please delete a Saved Search in order to Save this one!',
};
